module.exports = __webpack_public_path__ + "img/Rhett Marques.a4428141.jpg";